import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resetPassword } from 'actions/settings';

import PasswordResetModalComponent from './PasswordResetModalComponent';

export class PasswordResetModalContainer extends Component {
  handleSubmit = ({ password }, actions) => {
    const { dispatch, token } = this.props;
    if (!(password && token)) {
      actions.isSubmitting = false;
      return;
    }
    dispatch(resetPassword({ password, token }));
  }

  render = () => {
    const { isOpen, onRequestClose } = this.props;
    return (
      <PasswordResetModalComponent
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default connect()(PasswordResetModalContainer);